import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, useTheme } from "@material-ui/core";
import translate from "i18n/translate";
import { Typography } from "components/common";
import useStyles from "./invoicesStyles";
import { useIntl } from "react-intl";

const InvoicesActions = ({ showManualBilling, onBillingClick }) => {
  const classes = useStyles();
  const { palette } = useTheme();
  const intl = useIntl();

  return (
    <Grid container>
      {showManualBilling ? (
        <>
          <Grid item container xs={12} md={6} justifyContent="center">
            <Box
              className={classes.contentBox}
              onClick={() => onBillingClick(true)}
              bgcolor={palette.primary.altern}
              marginRight={1}
            >
              <img
                className={classes.boxImg}
                src="/invoices/invoice-config.svg"
                alt={intl.formatMessage({
                  id: "invoices.automaticInvoice.heading",
                })}
              />
              <Grid container spacing={1} justifyContent="center">
                <Grid item>
                  <Typography
                    variant="h3SemiBold"
                    className={classes.whiteFont}
                  >
                    {translate("invoices.automaticInvoice.heading")}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.whiteFont}>
                    {translate("invoices.automaticInvoice.content")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              className={classes.contentBox}
              onClick={() => onBillingClick(false)}
              bgcolor={palette.primary.main}
              marginLeft={1}
            >
              <img
                className={classes.boxImg}
                src="/invoices/invoice-new.svg"
                alt={intl.formatMessage({
                  id: "invoices.manualInvoice.heading",
                })}
              />
              <Grid container spacing={1} justifyContent="center">
                <Grid item>
                  <Typography
                    variant="h3SemiBold"
                    className={classes.whiteFont}
                  >
                    {translate("invoices.manualInvoice.heading")}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.whiteFont}>
                    {translate("invoices.manualInvoice.content")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </>
      ) : (
        <Grid item container xs={12}>
          <Box
            className={classes.justOneContentBox}
            onClick={() => onBillingClick(true)}
            bgcolor={palette.primary.altern}
          >
            <Box>
              <img
                className={`${classes.boxImg} ${classes.marginImg}`}
                src="/invoices/invoice-config.svg"
                alt={intl.formatMessage({
                  id: "invoices.automaticInvoice.heading",
                })}
              />
            </Box>
            <Grid container>
              <Grid item xs={12}>
                <Box marginBottom={2}>
                  <Typography
                    variant="h3SemiBold"
                    className={`${classes.whiteFont} ${classes.textCenter}`}
                  >
                    {translate("invoices.automaticInvoiceActive.heading")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.whiteFont}>
                  {translate("invoices.automaticInvoiceActive.content")}
                </Typography>
                <Typography className={classes.whiteFont}>
                  {translate("invoices.automaticInvoiceActive.content1")}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

InvoicesActions.propTypes = {
  showManualBilling: PropTypes.bool.isRequired,
  onBillingClick: PropTypes.func.isRequired,
};

export default InvoicesActions;
